export default __webpack_public_path__ + "static/media/pyposition_84a.46308c31.png";